<p-pickList [source]="values"
            [target]="targetValues"
            sourceHeader="{{labelFrom}}"
            targetHeader="{{labelTo}}"
            [dragdrop]="true"
            [responsive]="true"
            [sourceStyle]="{ height: '30rem' }"
            [targetStyle]="{ height: '30rem' }"
            filterBy="{{filterBy}}"
            sourceFilterPlaceholder="{{filterByLabel}}"
            targetFilterPlaceholder="{{filterByLabel}}"
            breakpoint="1400px"
            (onMoveToSource) = "onChange()"
            (onMoveAllToSource) = "onChange()"
            (onMoveAllToTarget) = "onChange()"
            (onMoveToTarget) = "onChange()"
            (onSourceReorder) = "onChange()"
            (onTargetReorder) = "onChange()"
            (onSourceSelect) = "onChange()"
            (onTargetSelect) = "onChange()"
            (onSourceFilter) = "onChange()"
            (onTargetFilter) = "onChange()"
            [showSourceControls] ="false"
            [showTargetControls] = "false">
    <ng-template let-item pTemplate="item">
        <div class="flex flex-wrap p-2 align-items-center gap-3">
            <div class="flex-1 flex flex-column gap-2 p-y">
                <div class="row info">
                    <div class="col-xs-10">
                        <div *ngIf="item.item.identifier" class="flex align-products-center gap-2">
                            <i class="pi pi-tag text-sm mx-10"></i>
                            <span class="font-bold">Identificativo : {{ item.item.identifier }}</span>
                        </div>
                    </div>
                    <div *ngIf="isTargetValue(item)" class="col-xs-2 position">
                        <div *ngIf="item.item.identifier" class="flex align-products-center gap-2">
                            <span class="font-bold"># {{ item.order }}</span>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div *ngIf="item.item.name" class="col-xs-12 info">
                        <div class="flex align-products-center gap-2">
                            <span class="font-bold">Nome : {{ item.item.name }}</span>
                        </div>
                    </div>
                    <div *ngIf="item.item.type" class="col-xs-12">
                        <div class="flex align-products-center gap-2">
                            <span>Tipo : {{ item.item.type.name }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</p-pickList>
